module.exports = __webpack_public_path__ + "static/4-bf93bbd2c37a40cf40db6d77f35dbaf6.jpg";